const setPatchPlaying = (isPlaying) => {
  return {
    type: 'SET_PATCH_PLAYING',
    isPlaying
  };
}

export default setPatchPlaying;



// WEBPACK FOOTER //
// ./src/actions/setPatchPlaying.js